module.exports = __webpack_public_path__ + "static/media/8_r_stena_84.27_0.e0bff258.png";